import React, { useState, useEffect, useCallback, useMemo } from 'react';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function RateReviews() {
  const [reviews, setReviews] = useState([]);
  const [clientRates, setClientRates] = useState([]);
  const [reviewMonth, setReviewMonth] = useState('');
  const [reviewStars, setReviewStars] = useState('');
  const token = localStorage.getItem('token');

  const getReviewMonth = (createdAt) => {
    if (!createdAt) return '';
    if (/^\d{4}-\d{2}/.test(createdAt)) return createdAt.slice(0, 7);

    const date = new Date(createdAt);
    if (Number.isNaN(date.getTime())) return '';

    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${date.getFullYear()}-${month}`;
  };

  const filteredClientRates = useMemo(() => {
    return clientRates.filter((rate) => {
      const matchesMonth = reviewMonth ? getReviewMonth(rate.created_at) === reviewMonth : true;
      const matchesStars = reviewStars ? Number(rate.qtd_estrelas) === Number(reviewStars) : true;
      return matchesMonth && matchesStars;
    });
  }, [clientRates, reviewMonth, reviewStars]);

  const hasActiveFilters = Boolean(reviewMonth || reviewStars);

  const fetchGoogleReviews = useCallback(async (placeId) => {
    if (!placeId) {
      console.log('Place ID nao fornecido, pulando busca de avaliacoes do Google.');
      return;
    }

    try {
      const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
      const response = await fetch(`https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=reviews&key=${apiKey}`);
      const data = await response.json();

      if (data.result && data.result.reviews) {
        setReviews(data.result.reviews);
      } else {
        console.log('Nenhuma avaliacao do Google encontrada ou erro na API:', data.status);
      }
    } catch (error) {
      console.error('Erro ao buscar avaliacoes do Google:', error);
    }
  }, []);

  const fetchClientRates = useCallback(async () => {
    try {
      const companyId = localStorage.getItem('company_id');
      const response = await fetch(`${API_URL}/rates/company/${companyId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (Array.isArray(data)) {
        setClientRates(data);
      }
    } catch (error) {
      console.error('Erro ao buscar avaliacoes locais:', error);
    }
  }, [token]);

  useEffect(() => {
    const fetchAllData = async () => {
      await fetchClientRates();

      const companyId = localStorage.getItem('company_id');
      if (companyId) {
        try {
          const response = await fetch(`${API_URL}/companies/${companyId}/placeid`, {
            headers: { 'Authorization': `Bearer ${token}` },
          });
          const data = await response.json();
          if (response.ok && data.placeid) {
            await fetchGoogleReviews(data.placeid);
          }
        } catch (error) {
          console.error('Erro ao buscar o Place ID:', error);
        }
      }
    };
    fetchAllData();
  }, [fetchClientRates, fetchGoogleReviews, token]);

  return (
    <div className="reviews-container">
      <h2 style={{ marginTop: 40 }}>Avalia&ccedil;&otilde;es Internas</h2>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px', marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <div className="filter-group">
          <label htmlFor="reviewMonth">M&ecirc;s da avalia&ccedil;&atilde;o:</label><br />
          <input
            type="month"
            id="reviewMonth"
            value={reviewMonth}
            onChange={(e) => setReviewMonth(e.target.value)}
            className="input-style"
          />
        </div>
        <div className="filter-group">
          <label htmlFor="reviewStars">N&iacute;vel de atendimento:</label><br />
          <select
            id="reviewStars"
            value={reviewStars}
            onChange={(e) => setReviewStars(e.target.value)}
            className="input-style"
          >
            <option value="">Todas as estrelas</option>
            {[1, 2, 3, 4, 5].map((stars) => (
              <option key={stars} value={stars}>
                {stars} estrela{stars > 1 ? 's' : ''}
              </option>
            ))}
          </select>
        </div>
        <div style={{ alignSelf: 'flex-end' }}>
          <button
            type="button"
            onClick={() => {
              setReviewMonth('');
              setReviewStars('');
            }}
            className="button-style cancel"
            disabled={!hasActiveFilters}
          >
            Limpar filtros
          </button>
        </div>
      </div>

      {filteredClientRates.length > 0 ? (
        <table className="reviews-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Nome</th>
              <th>Estrelas</th>
              <th>Coment&aacute;rio</th>
            </tr>
          </thead>
          <tbody>
            {filteredClientRates.map((rate) => (
              <tr key={rate.id}>
                <td>{rate.created_at ? new Date(rate.created_at).toLocaleString('pt-BR') : ''}</td>
                <td>{rate.nome_cliente || ''}</td>
                <td>
                  {[...Array(Number(rate.qtd_estrelas) || 0)].map((_, i) => (
                    <span key={i} style={{ color: '#800080', fontSize: 18 }}>&#9733;</span>
                  ))}
                </td>
                <td>{rate.comentario}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>{clientRates.length > 0 ? 'Nenhuma avaliacao encontrada para os filtros selecionados.' : 'Voce ainda nao possui avaliacoes.'}</p>
      )}

      <br />

      <h2>Avalia&ccedil;&otilde;es do Google</h2>
      {reviews.length > 0 ? (
        <table className="reviews-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Nome</th>
              <th>Email</th>
              <th>Pontua&ccedil;&atilde;o</th>
              <th>Resposta</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review, index) => (
              <tr key={index}>
                <td>{new Date(review.time * 1000).toLocaleDateString('pt-BR')}</td>
                <td>{review.author_name}</td>
                <td>{review.author_url || 'Nao disponivel'}</td>
                <td>{review.rating}</td>
                <td>{review.text || 'Sem resposta'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Nao ha avaliacoes disponiveis no momento.</p>
      )}
    </div>
  );
}

export default RateReviews;
